import * as React from 'react';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import type { ProposalListMemberStatus } from 'types';

import './proposal-favorite-icon.scss';

applyTranslations(require('./proposal-favorite-icon.i18n.json'));

type Props = {
  status: ProposalListMemberStatus,
  canAddToFavorite?: boolean,
  onToggleFavorite?: () => void,
  isFavorite: boolean
};

const FavoriteIcon = (
  {
    status,
    isFavorite,
    canAddToFavorite = false,
    onToggleFavorite = () => {}
  }: Props
) => {
  if ((!canAddToFavorite && !isFavorite) || status === 'declined') {
    return null;
  }

  const icon = (
    <SVGDynamicIcon
      name={(isFavorite) ? 'star-custom-bg' : 'star-custom-fg'}
      customColor="yellow"
      width={24}
      height={24}
      onClick={canAddToFavorite ? onToggleFavorite : undefined}
    />
  );

  const tooltipMessage = (canAddToFavorite)
    ? __t('proposal_favorite_icon_v2.add_to_favorite_tooltip')
    : __t('proposal_favorite_icon_v2.marked_as_favorite_tooltip');

  return (
    <div className="proposal-tile-favorite-icon">
      <Tooltip
        width="short"
        message={tooltipMessage}
      >
        {icon}
      </Tooltip>
    </div>
  );
};

export default FavoriteIcon;
